import { Col, Row, Spin, Typography } from "antd";
import DefaultImage from "assets/images/headerImage/EventsImage.png";
import axios from "axios";
import AboutCompany from "components/AboutCompany/AboutCompany";
import { message } from "components/Messages/Messages";
import RelevantStudies from "components/RelevantStudies/RelevantStudies";
import ResponsibleMember from "components/ResponsibleMember/ResponsibleMember";
import SanitizeHTML from "components/SanitizeHTML/SanitizeHTML";
import useViewport from "components/UseViewport/UseViewport";
import EventHeader from "containers/SingleEventPage/EventHeader/EventHeader";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { Event, EventResponsibility } from "interfaces/events";
import { useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { EventLocation } from "./interfaces";

const { Title, Text } = Typography;

const months = ["JAN", "FEB", "MAR", "APR", "MAI", "JUN", "JUL", "AUG", "SEP", "OKT", "NOV", "DES"];
const days = ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"];

const SingleEventPage = () => {
  const [event, setEvent] = useState<Event>();
  const [eventLocation, setEventLocation] = useState<EventLocation>();
  // const [eventType, setEventType] = useState<EventType>(); */
  const [responsibles, setResponsibles] = useState<EventResponsibility[]>();

  const { id } = useParams<{ id: string }>();
  const { width } = useViewport();
  const breakpoint = 992;

  const { currentUser, isLoadingCurrentUser } = useLoginContext();
  const history = useHistory();

  useEffect(() => {
    axios.get<Event>(`/events/all-events/${id}/`).then(response => {
      setEvent(response.data);
    });
  }, [id]);

  useEffect(() => {
    if (!event) return;
    axios.get<EventLocation>(`/events/locations/${event?.location}/`).then(response => {
      setEventLocation(response.data);
    });
  }, [event]);

  useEffect(
    function fetchResponsibles() {
      if (!event) return;
      axios.get<EventResponsibility[]>(`/events/${event.id}/event-responsibility/`).then(response => {
        setResponsibles(response.data);
      });
    },
    [event]
  );

  const mainResponsible = useMemo(() => responsibles?.find(r => r.responsibility_type === 1), [responsibles]);

  /*   useEffect(() => {
    axios.get<EventType>(`/events/event_type/${event?.event_type}/`).then(response => {
      setEventType(response.data);
    });
  }, [event]); */

  if (isLoadingCurrentUser) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!event) return null;

  const getLocation = () => {
    if (!eventLocation?.name) return "Ikke bestemt";
    return eventLocation.name;
  };

  const date = new Date(event.start);

  const getTime = () => {
    if (!event?.start) return "Ikke bestemt";
    return `${date?.getHours()}:${date.getMinutes()}`;
  };
  const getDay = () => {
    return date.getDay();
  };
  const getDate = () => {
    return date.getDate();
  };
  const getMonth = () => {
    return date.getMonth();
  };

  if (!currentUser) {
    history.push("/");
    message("error", "Du må logge inn eller registrere deg for å åpne arrangementer");
    return null;
  }

  if (isCompanyUser(currentUser) && event.company.id !== currentUser.id) {
    history.push("/");
    message("error", "Bedrifter kan kun åpne egne arrangementer");
    return null;
  }

  return (
    <>
      <EventHeader
        imageLink={`${event?.coverImage ? event?.coverImage : DefaultImage}`}
        alt="EventImage"
        id={event?.id}
        month={months[getMonth()]}
        date={`${getDate()}`}
        dayAndTime={`${days[getDay()]} - kl. ${getTime()}`}
        location={`${getLocation()}`}
        open={event.open}
        name={event.name ?? event.company}
        isOpen={event.is_open}
      />
      <br />
      <Row style={{ paddingTop: "5%" }} justify="center">
        <Col
          xs={24}
          md={24}
          lg={13}
          style={
            width < breakpoint ? { paddingLeft: "10%", paddingRight: "10%" } : { paddingLeft: "4%", paddingRight: "7%" }
          }
        >
          <Title level={4}>Beskrivelse</Title>
          <Text>
            <b>Sted: </b> {`${getLocation()}`}
          </Text>
          <br />
          <Text>
            <b>Servering: </b> {event?.food ? event?.food : "Ikke bestemt"}
          </Text>
          <br />
          {event?.duration ? (
            <Text>
              <b>Varighet: </b> {event?.duration}
            </Text>
          ) : null}
          <br />
          <SanitizeHTML html={event?.comments} />
          <br />
        </Col>
        <Col
          xs={24}
          md={24}
          lg={8}
          style={width < breakpoint ? { paddingLeft: "10%", paddingRight: "10%" } : { paddingRight: "4%" }}
        >
          <RelevantStudies eventId={event.id} />
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: "7%" }}>
        <ResponsibleMember activeMemberId={mainResponsible?.bl_member} closeTime={getTime()} />
      </Row>
      <Row justify="center" style={{ paddingLeft: "10%", paddingRight: "10%", marginTop: "7%" }}>
        <AboutCompany company={event.company} />
      </Row>
      <br />
    </>
  );
};

export default SingleEventPage;
